var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-box",class:{small: _vm.small, xsmall: _vm.xsmall, xlarge: _vm.xlarge, 'screen-sm': _vm.$vuetify.breakpoint.mdAndDown}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }